<template>
  <div class="content_safe">
    <div class="cs_banner">
      <div class="cs_banner_info">
        <h1 style="margin-bottom: 20px">精准拦截各类不良内容，杜绝下架风险</h1>
        <h2>
          提供实时图文音视频内容审核服务，高效过滤涉政暴恐、色情低俗、广告等不良信息，杜绝平台内容违规风险。
        </h2>
        <div class="cs_banner_ljsq" @click="showSubmitDialog">
          <p>立即咨询</p>
        </div>
      </div>
    </div>
    <div class="cs_tongdian">
      <h1>行业痛点</h1>
      <div class="cs_tongdian_content DFC">
        <div class="cs_tongdian_item">
          <img src="@/assets/images/content/tongdian1@2x.png" alt="" />
          <h2>监管力度加强</h2>
          <h3 class="Mt32">
            随着移动互联网的爆发式增长以及网络安全法的实施，内容平台运营者面临更加严峻的考验，
          </h3>
          <h3 class="Mt24">
            一方面是恶意用户增加，一方面是监管力度加强，一旦“下架”，所有努力付诸东流
          </h3>
        </div>
        <div class="cs_tongdian_item">
          <img src="@/assets/images/content/tongdian2@2x.png" alt="" />
          <h2>内容变化速度快</h2>
          <h3 class="Mt32">
            内容策略运营需要从发布前、发布后多个环节进行管控，专业性要求很高。
          </h3>
          <h3 class="Mt24">
            需要对行业舆情风向有更敏锐的洞察力以应对快速变化的有害内容。
          </h3>
        </div>
        <div class="cs_tongdian_item">
          <img src="@/assets/images/content/tongdian3@2x.png" alt="" />
          <h2>高额运营成本</h2>
          <h3 class="Mt32">需要7*24小时不间断服务，成本极高</h3>
          <h3 class="Mt24">
            可能面临内容不规律增长带来的人员短缺和冗余，导致资源浪费
          </h3>
          <h3 class="Mt24">密集型作业团队给管理也带来更多的风险和成本</h3>
        </div>
      </div>
    </div>
    <div class="cs_service">
      <h1>服务内容</h1>
      <div class="cs_service_content DFC">
        <div class="cs_service_item">
          <img src="@/assets/images/content/service1@2x.png" alt="" />
          <h2 class="Mt12 Mb24">内容安审智能识别引擎</h2>
          <h3>
            通过AI智能引擎识别文本、图像中的涉政暴恐、色情低俗、广告等不良信息，快速定位违规问题。
          </h3>
        </div>
        <div class="cs_service_item">
          <img src="@/assets/images/content/service2@2x.png" alt="" />
          <h2 class="Mt12 Mb24">内容安审人工审核</h2>
          <h3>
            通过人工审核，精准拦截涉政暴恐、色情低俗、广告等不良信息，彻底杜绝误拦、漏拦问题。
          </h3>
        </div>
      </div>
    </div>
    <div class="cs_liucheng">
      <h1>服务流程</h1>
      <div class="cs_liucheng_content">
        <img src="@/assets/images/content/liucheng@4x.png" alt="" />
      </div>
    </div>
    <div class="cs_youshi">
      <h1>服务优势</h1>
      <div class="cs_youshi_content DFC">
        <div class="cs_youshi_item">
          <img src="@/assets/images/content/youshi1@2x.png" alt="" />
          <h2>5分钟快速响应</h2>
          <h3>智能引擎毫秒级响应</h3>
          <h3>人工审核5分钟内响应</h3>
        </div>
        <div class="cs_youshi_item">
          <img src="@/assets/images/content/youshi2@2x.png" alt="" />
          <h2>99.5%正确率</h2>
          <h3>智能引擎正确率高于90%</h3>
          <h3>人工审核正确率高于99.5%</h3>
        </div>
        <div class="cs_youshi_item">
          <img src="@/assets/images/content/youshi3@2x.png" alt="" />
          <h2>0信息安全事故</h2>
          <h3>数据加密传输</h3>
          <h3>作业现场网络隔离</h3>
        </div>
        <div class="cs_youshi_item">
          <img src="@/assets/images/content/youshi4@2x.png" alt="" />
          <h2>人审规模400+</h2>
          <h3>团队规模超400人</h3>
          <h3>日审核内容超300W条</h3>
        </div>
      </div>
    </div>
    <div class="cs_hezuo">
      <h1>合作客户</h1>
      <div class="cs_hezuo_content DFC">
        <img src="@/assets/images/content/gongzhonghao@2x.png" alt="" />
        <img src="@/assets/images/content/kandian@2x.png" alt="" />
        <img src="@/assets/images/content/zhishixingqiu@2x.png" alt="" />
        <img src="@/assets/images/content/jinshan@2x.png" alt="" />
        <img src="@/assets/images/content/keep@2x.png" alt="" />
      </div>
      <div class="cs_hezuo_btn" @click="showSubmitDialog">
        <p>立即咨询</p>
      </div>
    </div>
    <submitDialog ref="submitDialog"></submitDialog>
  </div>
</template>

<script>
import submitDialog from '@/components/SubmitDialog'

export default {
  metaInfo: {
    title:
      '精准拦截各类不良有害内容，杜绝下架风险|文本审核_图片审核_视频审核_音频审核-知道创宇云安全',
  },
  components: {
    submitDialog,
  },
  methods: {
    showSubmitDialog() {
      this.$refs.submitDialog.dialogVisible = true
    },
  },
  mounted() {
    const mvp = document.getElementById('testViewport')
    mvp.setAttribute('content', 'width=1230')
  },
}
</script>

<style lang="scss">
.content_safe {
  color: #333;
  text-align: center;
  h1 {
    font-size: 30px;
    font-weight: 400;
  }
  h2 {
    font-size: 24px;
    font-weight: 400;
  }
  h3 {
    color: #888888;
    font-size: 16px;
    line-height: 2;
    font-weight: 400;
    text-align: left;
  }
  .cs_banner {
    background-image: url('../assets/images/content/banner@2x.png');
    background-position: center;
    background-size: cover;
    height: 380px;
    min-width: 1230px;
    text-align: left;
    .cs_banner_info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 1200px;
      height: 380px;
      margin: 0 auto;
      h1 {
        color: #ecedf4;
        font-size: 32px;
        margin-bottom: 30px;
      }
      h2 {
        color: #979bb6;
        font-size: 16px;
      }
      .cs_banner_ljsq {
        margin-top: 43px;
        cursor: pointer;
        width: 160px;
        height: 48px;
        background: url('../assets/images/content/ljsq_bg@2x.png') no-repeat;
        background-size: 160px 48px;
        &:hover {
          opacity: 0.9;
        }
        p {
          color: #fff;
          text-align: center;
          line-height: 48px;
          font-size: 18px;
        }
      }
    }
  }
  .cs_tongdian {
    background: #f6f8fb;
    padding-top: 63px;
    min-width: 1230px;
    padding-bottom: 79px;
    .cs_tongdian_item {
      width: 384px;
      height: 448px;
      border: 1px solid rgba(229, 229, 229, 1);
      margin-right: 23px;
      padding: 0 20px;
      margin-top: 63px;
      box-sizing: border-box;
      flex: none;
      &:last-child {
        margin-right: 0;
      }
      img {
        width: 120px;
        height: 120px;
        margin-top: 57px;
        margin-bottom: 16px;
      }
    }
  }
  .cs_service {
    padding: 80px 0 80px;
    min-width: 1230px;
    .cs_service_item {
      margin-top: 63px;
      width: 440px;
      height: 300px;
      margin-right: 79px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(229, 229, 229, 1);
      box-sizing: border-box;
      padding: 28px 42px 0;
      &:last-child {
        margin-right: 0;
      }
      img {
        width: 105px;
        height: 120px;
      }
    }
  }
  .cs_liucheng {
    background: #f6f8fb;
    min-width: 1230px;
    padding: 80px 0 80px;
    .cs_liucheng_content {
      margin-top: 64px;
      img {
        width: 1198px;
        height: 416px;
      }
    }
  }
  .cs_youshi {
    padding: 80px 0;
    min-width: 1230px;
    .cs_youshi_item {
      width: 280px;
      height: 280px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(229, 229, 229, 1);
      margin: 63px 24px 0 0;
      padding-top: 40px;
      box-sizing: border-box;
      &:last-child {
        margin-right: 0;
      }
      img {
        width: 80px;
        height: 80px;
      }
      h2 {
        margin-top: 16px;
        margin-bottom: 15px;
      }
      h3 {
        text-align: center;
      }
    }
  }
  .cs_hezuo {
    background: #f6f8fb;
    min-width: 1230px;
    padding: 80px 0 80px;
    .cs_hezuo_content {
      margin: 64px 0 80px;
    }
    img {
      width: 200px;
      height: 160px;
      margin-right: 31px;
      &:last-child {
        margin-right: 0;
      }
    }
    .cs_hezuo_btn {
      display: flex;
      justify-content: center;

      p {
        width: 160px;
        height: 48px;
        background: rgba(10, 158, 250, 1);
        border-radius: 2px;
        color: #fff;
        line-height: 48px;
        font-size: 18px;
        cursor: pointer;
        &:hover {
          opacity: 0.9;
        }
      }
    }
  }
}
</style>
